export default __webpack_public_path__ + "static/media/General_English.f934983b.png";